import { FORM_ERROR } from "final-form";
import { useIntl } from "react-intl";

import useTrashablePromises from "hooks/useTrashablePromises";
import translateError from "utils/translateError";
import useGlobalContext from "hooks/globalData";
import {
  ISaveResourceLibraryRequest,
  SaveResourceLibraryRequest,
} from "services/KnowfullyAdminClient";

import ResourceLibraryForm from "./ResourceLibraryForm";

type resourceLibraryUpdateFormProps = {
  resourceLibrary: ISaveResourceLibraryRequest;
  onResourceLibraryUpdated: () => void;
  onCancel: () => void;
};

const ResourceLibraryUpdateForm = ({
  resourceLibrary,
  onResourceLibraryUpdated,
  onCancel,
}: resourceLibraryUpdateFormProps) => {
  const { registerPromise } = useTrashablePromises();
  const { formatMessage: t } = useIntl();
  const { resourceLibraryService } = useGlobalContext();

  const onSubmit = (values: ISaveResourceLibraryRequest) => {
    return registerPromise(
      resourceLibraryService.saveResourceLibrary(
        new SaveResourceLibraryRequest({ ...values, id: resourceLibrary.id })
      )
    )
      .then(() => {
        onResourceLibraryUpdated();
      })
      .catch((err: any) => {
        return { [FORM_ERROR]: translateError(err, t) };
      });
  };

  return (
    <ResourceLibraryForm
      resourceLibrary={resourceLibrary}
      onSubmit={onSubmit}
      submitLabel={t({ id: "resourceLibraryFormUpdateButton" })}
      onCancel={onCancel}
    />
  );
};

export default ResourceLibraryUpdateForm;
